/* eslint-disable import/order */
// Import the polyfills ♥
import "ts-polyfill/lib/es2015-core";
import "ts-polyfill/lib/es2015-promise";
import "ts-polyfill/lib/es2015-collection";
import "ts-polyfill/lib/es2016-array-include";
import "ts-polyfill/lib/es2017-string";
import "ts-polyfill/lib/es2017-object";
import "ts-polyfill/lib/es2018-promise";

// Must be called early.
import "./router/routing-hooks";

import SlidingRouterView from "./components/sliding-router-view.vue";
import CsRouterView from "./router/cs-router-view.vue";
import StubRouterView from "./router/stub-router-view.vue";
import jQuery from "jquery";
import { Modal } from "uiv";
import CmsPage from "./views/cms/cms-page.vue";
import CmsSelect from "./components/cms/cms-select.vue";
import CmsSession from "./views/cms/cms-session.vue";
import SessionWrapper from "./components/sessions/session-wrapper.vue";
import ScriptSnippet from "./components/script-snippet.vue";
import StrengthsMapping from "./views/strengths-mapping/strengths-mapping.vue";
import StrengthsMappingPreCheck from "./views/strengths-mapping/strengths-mapping-pre-check.vue";
import InviteControl from "./components/invite-control/invite-control.vue";
import Sessions from "./views/sessions/sessions-wheel.vue";
import DevelopProgress from "./components/develop-progress.vue";
import init2 from "./init";
import DiamondHead from "./components/diamond-head.vue";
import HomePage from "./views/home-page.vue";
import GuestHomePage from "./views/guest/guest-home-page.vue";
import JyreFooter from "./components/jyre-footer.vue";
import StrengthsListInner from "./components/strengths-lists/strengths-list-inner.vue";
import CustomReportEditor from "./components/custom-report-editor.vue";
import CustomReportButton from "./components/custom-report-button.vue";
import ReportPermissionDialog from "./components/report-permission-dialog.vue";
import ReportPermissionControl from "./components/report-permission-control.vue";
import ResourceThemesList from "./components/cms/resource-themes-list.vue";
import ResourcePlaylist from "./views/cms/resource-playlist.vue";
import TreeVisual from "./components/sessions/tree-visual.vue";
import AdminSearchPage from "./views/admin/admin-search-page.vue";
import OrganisationFormField from "./components/admin/organisation/organisation-form-field.vue";
import DevelopDataExportPage from "./views/admin/develop-data-export-page.vue";
import Head from "./components/head/gyre-head.vue";
import CompareReportsButton from "./components/compare-reports-button.vue";
import NewSoloButton from "./components/new-solo-button.vue";
import ViewpointsPathwayContainer from "./views/viewpoints-pathways/viewpoints-pathway-container.vue";
import ViewpointsReportPathwayContainer from "./views/viewpoints-pathways/viewpoints-report-pathway-container.vue";
import CmsTextRenderer from "./components/cms/cms-text-renderer.vue";
import CompositeTeamHead from "./components/head/composite-team-head.vue";
import type { App } from "vue";
import RootAppComponent from "./App.vue";

import uiConfig2 from "./ui-config";

// Styles must be imported in this order.
import "./styles/libre-franklin-font.css";
import "./styles/bootstrap/bootstrap.less";
import "./styles/site.less";
import CmsBody from "./components/cms/cms-body.vue";
import TeamEffectivenessBarGraph from "./components/team-effectiveness/team-effectiveness-bar-graph.vue";
import CustomSoloBarGraph from "./components/custom-reports/custom-solo-bar-graph.vue";
import CustomViewpointsBarGraph from "./components/custom-reports/custom-viewpoints-bar-graph.vue";
import SearchBar from "./components/search-bar.vue";
import GyreNavbars from "./components/navbars/gyre-navbars.vue";
import ShareButton from "./components/share-button.vue";
import GroupMemberTable from "./components/group-member-table/group-member-table.vue";
import { TextFromPrismic } from "./directives/text-from-prismic";
import CustomSoloReport from "./views/custom-solo-report.vue";
import OrganisationHeads from "./components/admin/organisation/organisation-heads.vue";
import OrganisationReport from "./views/admin/organisation-report.vue";
import InvitesRestricted from "./views/error-pages/invites-restricted.vue";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import localizedDateFormat from "dayjs/plugin/localizedFormat";
import utc from "dayjs/plugin/utc";
import calendar from "dayjs/plugin/calendar";
import relativeTime from "dayjs/plugin/relativeTime";
import "datatables.net-bs/css/dataTables.bootstrap.css";
import { createPinia } from "pinia";

// For Lottie animations
import "@lottiefiles/lottie-player";

import cms2 from "./services/cms/cms";

import router, { goToPrismic } from "./router/router";
import clickOutsideDirective from "./directives/click-outside";
import markdownDirective from "./directives/markdown";
import dataTableDirective from "./directives/data-table";

import UserAccreditationManager from "./components/admin/user-accreditation-manager.vue";

dayjs.extend(customParseFormat);
dayjs.extend(calendar);
dayjs.extend(relativeTime);
dayjs.extend(localizedDateFormat);
dayjs.extend(utc);

(window as any).$ = jQuery;
(window as any).jQuery = jQuery;

// We import DataTables.net but don't actually initialize it (as the library doesn't seem to play nicely)
// eslint-disable-next-line @typescript-eslint/no-var-requires
require("datatables.net");

export function setupGlobals(app: App): void {
  app.component("jyre-footer", JyreFooter);
  app.component("CmsTextRenderer", CmsTextRenderer);

  app.directive("text-from-prismic", TextFromPrismic);
  app.directive("click-outside", clickOutsideDirective);
  app.directive("markdown", markdownDirective);
  app.directive("data-table", dataTableDirective);
}

export const pinia = createPinia();

export const components = {
  CmsPage,
  CmsBody,
  SessionWrapper,
  InviteControl,
  StrengthsMapping,
  Sessions,
  CmsSession,
  DiamondHead,
  DevelopProgress,
  ScriptSnippet,
  StrengthsListInner,
  CustomReportEditor,
  Modal,
  CustomReportButton,
  ReportPermissionDialog,
  ReportPermissionControl,
  TreeVisual,
  ResourceThemesList,
  ResourcePlaylist,
  SlidingRouterView,
  CsRouterView,
  CmsSelect,
  StrengthsMappingPreCheck,
  HomePage,
  JyreFooter,
  AdminSearchPage,
  TeamEffectivenessBarGraph,
  CustomSoloBarGraph,
  CustomViewpointsBarGraph,
  StubRouterView,
  ShareButton,
  OrganisationFormField,
  SearchBar,
  GroupMemberTable,
  GyreNavbars,
  CustomSoloReport,
  DevelopDataExportPage,
  OrganisationHeads,
  OrganisationReport,
  InvitesRestricted,
  Head,
  CompareReportsButton,
  NewSoloButton,
  GuestHomePage,
  ViewpointsPathwayContainer,
  ViewpointsReportPathwayContainer,
  App: RootAppComponent,
  CompositeTeamHead,
  UserAccreditationManager,
};

export const init = init2;

export const uiConfig = uiConfig2;

export const cms = cms2;

export { router, goToPrismic };
